import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './style.scss';


class Rating extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: this.props.initialRating,
    };
  }

  componentWillReceiveProps({ initialRating }) {
    if (this.props.initialRating !== initialRating) {
      this.setState({
        rating: initialRating,
      });
    }
  }

  handleClickRating(value) {
    const { onRate } = this.props;
    this.setState((currentState) => {
      if (currentState.rating === value) {
        onRate(null);
        return {
          rating: null,
        };
      }
      else {
        onRate(value);
        return {
          rating: value,
        };
      }
    });
  }

  render() {
    const { rating } = this.state;
    const { fullSymbol, emptySymbol } = this.props;
    const ratingWidth = rating || 0;
    const ratingStyle = {
      width: `${ratingWidth * 32}px`,
    };
    const elementCount = 5;
    return (
      <div className={styles.ratingStar}>
        {[...Array(elementCount)].map((item, key) => {
          const value = key + 1;
          return (
            <span
              className={classNames(styles.emptyStar, 'jest-user-rating-empty')}
              key={value}
              onClick={() =>this.handleClickRating(value)}>
              {emptySymbol}
            </span>
          );
        })}
        <div
          className={classNames(styles.ratingStarHover, 'jest-user-rating-full')}
          style={ratingStyle}>
          {[...Array(elementCount)].map((item, key) => {
            const value = key + 1;
            return (
              <span
                className={styles.filledStar}
                key={key}
                onClick={() =>this.handleClickRating(value)}>
                {fullSymbol}
              </span>
            );
          })}
        </div>
      </div>
    );
  }
}

Rating.propTypes = {
  initialRating: PropTypes.number,
  fullSymbol: PropTypes.element.isRequired,
  emptySymbol: PropTypes.element.isRequired,
};

export default Rating;
